export enum ReservedPresetAreas {
  PresetFloating = 'PresetFloating',
  BottomBar = 'BottomBar',
  BottomBarLeftControls = 'BottomBarLeftControls',
  BottomBarRightControls = 'BottomBarRightControls',
  TopBarLeftControls = 'TopBarLeftControls',
  TopBarRightControls = 'TopBarRightControls',
  SidePanelTop = 'SidePanelTop',
  InteractiveAreaSidePanelLeft = 'SidePanelLeft',
  SidePanelRight = 'SidePanelRight',
  SidePanelBottom = 'SidePanelBottom',
  PresetArea = 'PresetArea',
  InteractiveArea = 'InteractiveArea',
  PlayerArea = 'PlayerArea',
  VideoArea = 'VideoArea',
  VideoContainer = 'VideoContainer'
}
